import React, { memo } from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import { IShipment } from 'types/shipment'
import { DAT_FLAGS } from 'apps/booking/constants/loadBoardPosts'
import { RejectedFilledIcon, SuccessIcon, EditIcon } from 'transfix-icons'
import formatCurrency from 'utils/formatCurrency'

interface IMarketplaceSettingsProps {
  shipment?: IShipment
  openSettings: () => void
  editedString: string
}

export const MarketplaceSettings = memo<IMarketplaceSettingsProps>(
  ({ editedString, openSettings, shipment }) => {
    const listPrice = shipment?.carrierPayment.tcmCarrierPrices?.listPrice || '0'
    const flags = shipment?.flags || []

    const On = () => (
      <span data-test='success'>
        <SuccessIcon size='large' color='info' className='inline' />
      </span>
    )
    const Off = () => (
      <span data-test='rejected'>
        <RejectedFilledIcon className='inline' size='large' />
      </span>
    )
    const onMarketplace = flags.find((f: string) => f === DAT_FLAGS.marketOnMarketplace)
    const onLoadBoard = flags.find((f: string) => f === DAT_FLAGS.marketOnLoadBoards)

    return (
      <>
        <div className='row'>
          <div className='fl'>
            <div className='body-medium'>Marketplace Settings</div>
            <div className='text-caption-semibold'>{editedString}</div>
          </div>
          <div className='fr'>
            <IconButton
              Icon={EditIcon}
              color='tertiary'
              onClick={openSettings}
              data-test='edit-marketplace-settings'
              label='Edit Marketplace Settings'
              size='large'
            />
          </div>
        </div>
        <div className='row mv4'>
          <strong data-test='marketplace-list-price'>{formatCurrency(listPrice)}</strong>
          <div className='text-caption-semibold text-default'>List Rate</div>
        </div>
        <div className='row mv4'>
          <div className='flex flex-row items-center mb2' data-test='listed-on-marketplace'>
            {onMarketplace ? <On /> : <Off />}
            &nbsp; List on Transfix app
          </div>
          <div className='flex flex-row items-center mb2' data-test='posted-to-dat'>
            {onLoadBoard ? <On /> : <Off />}
            &nbsp; Post to DAT
          </div>
        </div>
      </>
    )
  }
)
